import React from 'react';
import { withRouter } from 'react-router-dom';
import { equal } from 'helpers/deep';
import isEdgeIE from 'helpers/detectEdgeIE';
import PropTypes from 'prop-types';


class ScrollToTop extends React.Component {
  componentDidMount() {
    if (this.props.scrollTopOnMount) {
      const appbody = document.body.querySelector('.app__content__body');
      if (appbody) appbody.scrollTop = 0;
    }
  }

  componentDidUpdate(prevProps) {
    if (isEdgeIE()) {
      return;
    }

    if (!equal(prevProps.location, this.props.location)) {
      const appbody = document.body.querySelector('.app__content__body');
      if (appbody) appbody.scrollTop = 0;
    }
  }

  render() {
    return null;
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string }),
  scrollTopOnMount: PropTypes.bool,
};

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/ScrollToTop/ScrollToTop.jsx